import { useEffect, useRef, useState } from "react";
import { Breadcrumb, Button, FloatingLabel, Form, Modal } from "react-bootstrap";
import LoadingComponent from "../../../widgets/LoadingComponent";
import AsyncSelect from 'react-select/async';
import { getData, postData } from "../../../api/ApiRest";
import { useNavigate, useParams } from "react-router-dom";
import { FaPlus, FaRegClipboard, FaRocket, FaTrash } from "react-icons/fa6";
import { formatNumber } from "../../../widgets/FormatNumber";
import { FaCheck, FaSave } from "react-icons/fa";
import auditoriaSet from "../../../widgets/Auditoria";
import { useSelector } from "react-redux";
import { Grid, Paper, Typography } from "@mui/material";

function FacturaCRUD() {
    const [loading, setLoading] = useState(false);
    const [dataFactura, setDataFactura] = useState({});
    const [detalles, setDetalles] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);

    const [infoPlan, setInfoPlan] = useState({
        ModalVisible: false, Titulo: ''
    });

    const [dataPlan, setDataPlan] = useState({});
    const [listPrecios, setListPrecios] = useState([]);
    const [modalPrecio, setModalPrecio] = useState({
        ModalVisible: false, Titulo: ''
    });
    const [isEmpty, setIsEmpty] = useState(false);

    const companyId = useSelector((state) => state.auth.CompanyId);

    const selectRef = useRef(null);

    const navigate = useNavigate();
    const id = useParams().id;

    useEffect(() => {
        setDataFactura({ Fecha: new Date().toISOString().split('T')[0] });

        ///Solamente precarga cuando haya algo en la ruta
        if (id !== '0')
            getDetalles();
    }, [id]);

    const companieSearchSelect2 = async (Param) => {
        return await getData('api/Configuracion/Company/Select2Company',
            { param: Param }, false).then(response => {
                return response.companies;
            }, error => {
                return [];
            })
    }

    const productoSearchSelect2 = async (Param) => {
        return await getData('api/Configuracion/UtilityPublic/Select2Producto', { param: Param }, false).then(response => {
            return response.productos;
        }, error => {
            return [];
        })
    }

    ///Función para guardar el encabezado de un item
    const guardarEnc = (event) => {
        event.preventDefault();
        setLoading(true);

        ///Validamos el tipo de id, si es distinto del por defecto realiza validación previa
        if (id !== '0') {
            alert('No puedes volver a guardar esta venta');
            setLoading(false);
            return;
        }

        getData('api/Configuracion/Factura/guardarEncFactura', {
            fecha: dataFactura.Fecha,
            cliente: dataFactura.Cliente,
            prefijo: dataFactura.Prefijo,
            id: id || ''
        }).then(response => {
            navigate('/Home/FacturaCRUD/' + response.facturaid);

            auditoriaSet(dataFactura, {}, 'C', 'Factura', companyId || '', 'CreaEnc');

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Función para guardar el detalle de un item
    const guardarDetalle = () => {
        setLoading(true);

        let objecto = {
            Producto: dataFactura.Producto,
            Precio: dataFactura.Precio,
            Cantidad: dataFactura.Cantidad,
            Total: dataFactura.Total,
            Codigo: dataFactura.Cod_Producto,
            Descripcion: dataFactura.Descripcion,
            VlrBruto: dataFactura.VlrBruto,
            Descuento: dataFactura.Descuento,
            Subtotal: dataFactura.Subtotal,
            Impuesto: dataFactura.Impuesto
        };

        postData('api/Configuracion/Factura/guardarDetFactura', {
            id: id
        }, objecto).then(response => {
            if (response.status) {
                setDetalles((prev) => [...prev, response.objectoItem]);

                auditoriaSet(objecto, {}, 'C', 'Factura', companyId || '', 'AgregaItem');
            } else
                alert(response.msj);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    //Función para obtener la información de la factura
    const getDetalles = () => {
        setLoading(true);

        getData('api/Configuracion/Factura/getDataFactura', { id: id }).then(response => {
            setDataFactura({
                Fecha: response.client.fecha.split('T')[0],
                Cliente: response.client.cliente,
                Prefijo: response.client.prefijo,
                Numero: response.client.numero
            });
            setDetalles(response.list);

            setSelectedOptions({
                value: response.client.cliente,
                label: response.client.infoCliente
            });

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Eliminar detalles uno a uno
    const eliminarDetalle = (facturadetid) => {
        setLoading(true);

        let objecto = detalles.filter(x => x.facturadetid === facturadetid)[0];

        getData('api/Configuracion/Factura/eliminarDetalle', { facturadetid: facturadetid }).then(response => {
            if (response.status) {
                alert('Item eliminado con éxito');
                setDetalles(prev => prev.filter(item => item.facturadetid !== facturadetid));

                auditoriaSet(objecto, {}, 'E', 'Factura', companyId || '', 'EliminaItem');
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    ///Acción para enviar una venta a posgold
    const enviarVenta = () => {
        setLoading(true);

        let objecto = {
            nit: '',
            prefijo: dataFactura.Prefijo,
            fecha: dataFactura.Fecha,
            detalles
        };

        postData('api/Configuracion/Factura/enviarVenta', {
            Facturaid: id,
            Cliente: dataFactura.Cliente,
        }, objecto).then(response => {
            if (response.status) {
                alert(response.msj);
                window.location.reload();
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Acción para obtener la información de los planes
    const obtenerInfoPlan = () => {
        setLoading(true);

        getData('api/Configuracion/Factura/obtenerInfoPlan', {
            id: id
        }).then(response => {
            setDataPlan({
                planid: response.list[0].planid,
                plan: response.list[0].plan,
                factura: response.list[0].factura,
                foliosAnual: response.list[0].foliosAnual,
                foliosMes: response.list[0].foliosMes,
                valorAnual: response.list[0].valorAnual,
                valorMes: response.list[0].valorMes,
                valorAnualOriginal: response.list[0].valorAnual,
                valorMesOriginal: response.list[0].valorMes
            });

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Acción para generar un plan desde una factura de venta
    const generarPlan = (plan) => {
        setLoading(true);

        postData('api/Configuracion/Factura/generarPlanVenta', {
            id: id
        }, plan).then(response => {
            if (response.status) {
                alert(response.msj);

                setInfoPlan({
                    ModalVisible: false,
                    Titulo: ''
                });
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Función para recalcular las fechas de acuerdo al tipo de plan que se haya seleccionado
    const calculaFechasPlan = (tipo) => {
        setLoading(true);

        getData('api/Configuracion/Factura/calculaFechasPlan', {
            id: id,
            tipo: tipo
        }).then(response => {
            setDataPlan({
                ...dataPlan,
                fechaIni: response.list[0].fechaIni.split("T")[0],
                fechaFin: response.list[0].fechaFin.split("T")[0],
                esPadre: response.list[0].esPadre,
                padreId: response.list[0].padreId
            });

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Función global que me permite obtener un resumen de las ventas
    const resumenVenta = (tipo = '') => {
        let total = 0;

        detalles.map((item) => {
            total += item[tipo]
        })

        return total;
    }

    ///Función para abrir un modal en la cual podre seleccionar un nivel de precio de ciertos productos en especifico
    const handleKey = (event, producto) => {
        setLoading(true);
        event.preventDefault();

        getData('api/Configuracion/Factura/visualizarPrecios', {
            cod_producto: producto
        }).then(response => {
            setListPrecios(response.list);

            setModalPrecio({
                ModalVisible: true, Titulo: 'Lista de precios'
            });

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    return <div className='BodyComponent'>
        <Breadcrumb color='black'>
            <Breadcrumb.Item style={{ fontSize: 14 }}>Home</Breadcrumb.Item>
            <Breadcrumb.Item style={{ fontSize: 14 }} href="/Home/Factura">Factura</Breadcrumb.Item>
            <Breadcrumb.Item style={{ fontSize: 14 }} active={true}>FacturaCRUD</Breadcrumb.Item>
        </Breadcrumb>

        {<LoadingComponent Loading={loading} />}

        <Grid container spacing={3}>
            <Grid item xs={12} md={10}>
                <Paper sx={{ p: 1, borderRadius: 3 }}>
                    <Form onSubmit={guardarEnc}>
                        <div className="row">
                            <div className='col-md-2'>
                                <FloatingLabel controlId="fechaNewInput" label="Fecha" className="form-floating-sm">
                                    <Form.Control
                                        as="input"
                                        type="date"
                                        value={dataFactura.Fecha}
                                        onChange={event => setDataFactura({ ...dataFactura, Fecha: event.target.value })}
                                        placeholder=" "
                                        className="input-fecha-sm"
                                    />
                                </FloatingLabel>
                            </div>
                            <div className='col-md-5'>
                                <AsyncSelect cacheOptions defaultOptions
                                    menuPosition='fixed'
                                    noOptionsMessage={() => 'Escriba para iniciar la busqueda'}
                                    placeholder="Cliente"
                                    isClearable={true}
                                    loadOptions={companieSearchSelect2}
                                    onChange={value => {
                                        if (value === null) {
                                            setDataFactura({ ...dataFactura, Cliente: '' });
                                            setSelectedOptions({ ...selectedOptions, value: null, label: null });
                                        } else {
                                            setDataFactura({ ...dataFactura, Cliente: value.value });
                                            setSelectedOptions({ ...selectedOptions, value: value.value, label: value.label });
                                        }
                                    }}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minHeight: 50
                                        }),
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                    }}
                                    value={selectedOptions}
                                />
                            </div>
                            <div className='col-md-2'>
                                <FloatingLabel controlId="PrefijoNewInput" label="Prefijo" className="form-floating-sm">
                                    <Form.Control
                                        as="input"
                                        type="text"
                                        value={dataFactura.Prefijo}
                                        onChange={event => setDataFactura({ ...dataFactura, Prefijo: event.target.value })}
                                        autoComplete="off"
                                        className="input-fecha-sm"
                                    />
                                </FloatingLabel>
                            </div>
                            <div className='col-md-2'>
                                <FloatingLabel controlId="NúmeroNewInput" label="Número" className="form-floating-sm">
                                    <Form.Control
                                        as="input"
                                        type="text"
                                        value={dataFactura.Numero}
                                        readOnly
                                        className="input-fecha-sm"
                                    />
                                </FloatingLabel>
                            </div>

                            <div className='col-md-1'>
                                <Button variant='success' size="sm" type='submit' style={{ fontSize: 10, width: 40 }}>
                                    <FaSave size={'0.8rem'} />
                                </Button>
                            </div>
                        </div>
                    </Form>
                </Paper>

                <Paper sx={{ p: 1, mt: 1, borderRadius: 3 }}>

                    <Grid container spacing={1} mt={1}>
                        <Grid item xs={5}>
                            <AsyncSelect cacheOptions defaultOptions
                                menuPosition='fixed'
                                noOptionsMessage={() => 'Escriba para iniciar la busqueda'}
                                placeholder="Producto"
                                isClearable={true}
                                loadOptions={productoSearchSelect2}
                                onChange={value => {
                                    if (value === null) {
                                        setDataFactura({
                                            ...dataFactura,
                                            Producto: '',
                                            Precio: 0,
                                            Cantidad: 0,
                                            Total: 0,
                                            Cod_Producto: '',
                                            Descripcion: '',
                                            Subtotal: 0,
                                            Descuento: 0,
                                            Impuesto_porc: 0,
                                            Impuesto: 0
                                        })
                                    } else {
                                        let total = Math.round(value.precio * (1 + (value.impuesto_porc / 100)));
                                        let subtotal = Math.round(total / (1 + (value.impuesto_porc / 100)) * 100) / 100;
                                        let impuesto = Math.round((total - subtotal) * 100) / 100;

                                        setDataFactura({
                                            ...dataFactura,
                                            Producto: value.value,
                                            Precio: value.precio,
                                            Cantidad: 1,
                                            Total: total,
                                            Cod_Producto: value.codigo,
                                            Descripcion: value.producto,
                                            Subtotal: value.precio,
                                            Descuento: 0,
                                            Impuesto_porc: value.impuesto_porc,
                                            Impuesto: impuesto,
                                            VlrBruto: value.precio * 1
                                        });
                                    }
                                }}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: 50
                                    }),
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                }}
                                isDisabled={
                                    id === ':id' ? true : false
                                }
                                ref={selectRef}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <FloatingLabel controlId="CantidadNewInput" label="Cantidad" className="form-floating-sm">
                                <Form.Control
                                    as="input"
                                    type="number"
                                    value={dataFactura.Cantidad}
                                    onChange={event => {
                                        let vlrBruto = Math.round((dataFactura.Precio * event.target.value) * 100) / 100;
                                        let descuento = Math.round(vlrBruto * (dataFactura.Descuento / 100) * 100) / 100;
                                        let subtotal = Math.round((vlrBruto - descuento) * 100) / 100;
                                        let impuesto = Math.round(subtotal * (dataFactura.Impuesto_porc / 100) * 100) / 100;
                                        let total = Math.round((subtotal + impuesto) * 100) / 100;

                                        setDataFactura({ ...dataFactura, Cantidad: event.target.value, Total: total, Subtotal: subtotal, VlrBruto: vlrBruto, Impuesto: impuesto });
                                    }}
                                    readOnly={id === ':id' ? true : false}
                                    className="input-fecha-sm"
                                />
                            </FloatingLabel>
                        </Grid>
                        <Grid item xs={2}>
                            <FloatingLabel controlId="PrecioNewInput" label="Precio" className="form-floating-sm">
                                <Form.Control
                                    as="input"
                                    type="number"
                                    value={dataFactura.Precio}
                                    onChange={event => {
                                        if (event.target.value === '') {
                                            setIsEmpty(true);
                                        } else {
                                            setIsEmpty(false);
                                        }

                                        let vlrBruto = Math.round((event.target.value * dataFactura.Cantidad) * 100) / 100;
                                        let descuento = Math.round(vlrBruto * (dataFactura.Descuento / 100) * 100) / 100;
                                        let subtotal = Math.round((vlrBruto - descuento) * 100) / 100;
                                        let impuesto = Math.round(subtotal * (dataFactura.Impuesto_porc / 100) * 100) / 100;
                                        let total = Math.round((subtotal + impuesto) * 100) / 100;

                                        setDataFactura({ ...dataFactura, Precio: event.target.value, Total: total, Subtotal: subtotal, VlrBruto: vlrBruto, Impuesto: impuesto });
                                    }}
                                    onKeyDown={event => {
                                        if (event.key === 'Enter' && isEmpty) {
                                            handleKey(event, dataFactura.Cod_Producto);
                                        }
                                    }}
                                    readOnly={id === ':id' ? true : false}
                                    className="input-fecha-sm"
                                />
                            </FloatingLabel>
                        </Grid>
                        <Grid item xs={2}>
                            <FloatingLabel controlId="DescuentoNewInput" label="Descuento" className="form-floating-sm">
                                <Form.Control
                                    as="input"
                                    type="number"
                                    value={dataFactura.Descuento}
                                    onChange={event => {
                                        let vlrBruto = Math.round((dataFactura.Precio * dataFactura.Cantidad) * 100) / 100;
                                        let descuento = Math.round(vlrBruto * (event.target.value / 100) * 100) / 100;
                                        let subtotal = Math.round((vlrBruto - descuento) * 100) / 100;
                                        let impuesto = Math.round(subtotal * (dataFactura.Impuesto_porc / 100) * 100) / 100;
                                        let total = Math.round((subtotal + impuesto) * 100) / 100;

                                        setDataFactura({ ...dataFactura, Descuento: event.target.value, Subtotal: subtotal, Total: total, Impuesto: impuesto });
                                    }}
                                    readOnly={id === ':id' ? true : false}
                                    className="input-fecha-sm"
                                />
                            </FloatingLabel>
                        </Grid>
                        <Grid item xs={2}>
                            <FloatingLabel controlId="SubtotalNewInput" label="Subtotal" className="form-floating-sm">
                                <Form.Control
                                    as="input"
                                    type="number"
                                    value={dataFactura.Subtotal}
                                    readOnly
                                    className="input-fecha-sm"
                                />
                            </FloatingLabel>
                        </Grid>
                        <Grid item xs={2}>
                            <FloatingLabel controlId="ImpuestoNewInput" label="Impuesto" className="form-floating-sm">
                                <Form.Control
                                    as="input"
                                    type="number"
                                    value={dataFactura.Impuesto}
                                    readOnly
                                    className="input-fecha-sm"
                                />
                            </FloatingLabel>
                        </Grid>
                        <Grid item xs={2}>
                            <FloatingLabel controlId="TotalNewInput" label="Total" className="form-floating-sm">
                                <Form.Control
                                    as="input"
                                    type="number"
                                    value={dataFactura.Total}
                                    readOnly
                                    className="input-fecha-sm"
                                />
                            </FloatingLabel>
                        </Grid>
                        <Grid item xs={1}>
                            <Button variant="success" size="sm" type="button" hidden={id === ':id' ? true : false} onClick={() => {
                                guardarDetalle();

                                setDataFactura({
                                    Producto: null,
                                    Precio: 0,
                                    Cantidad: 0,
                                    Total: 0,
                                    Cod_Producto: null,
                                    Descripcion: null
                                });

                                selectRef.current?.clearValue(); ///Proceso para limpiar un producto después de agregarlo
                            }}>
                                <FaPlus size={'0.8rem'} style={{ textAlign: 'center', justifyItems: 'center', alignItems: 'center' }} />
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
            <Grid item xs={12} md={2}>
                <Paper sx={{ borderRadius: 3, backgroundColor: '#eef1f5' }}>
                    <Typography variant="h6" color="primary" fontWeight="bold" style={{ textAlign: 'center' }}>
                        Subtotal:
                    </Typography>
                    <Typography variant="h6" fontWeight="bold" style={{ textAlign: 'center', fontSize: 16 }}>
                        $ {formatNumber(resumenVenta('subtotal'))}
                    </Typography>
                    <Typography variant="h6" color="primary" fontWeight="bold" style={{ textAlign: 'center' }}>
                        Impuesto:
                    </Typography>
                    <Typography variant="h6" fontWeight="bold" style={{ textAlign: 'center', fontSize: 16 }}>
                        $ {formatNumber(resumenVenta('impuesto'))}
                    </Typography>
                    <Typography variant="h6" color="primary" fontWeight="bold" style={{ textAlign: 'center' }}>
                        Total:
                    </Typography>
                    <Typography variant="h6" fontWeight="bold" style={{ textAlign: 'center', fontSize: 16 }}>
                        $ {formatNumber(resumenVenta('total'))}
                    </Typography>
                </Paper>


                <Grid container spacing={1} style={{ textAlign: 'center', marginTop: 3 }}>
                    <Grid item xs={4}>
                        <Button variant='primary' type='button' size="sm" title="Nueva factura"
                            onClick={() => {
                                navigate('/Home/FacturaCRUD/0');

                                window.location.reload();
                            }}>
                            <FaPlus size={'0.8rem'} />
                        </Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button variant='warning' type='button' size="sm" onClick={() => enviarVenta()} title="Enviar factura">
                            <FaRocket size={'0.8rem'} />
                        </Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button variant='dark' title="Crear plan" size="sm" type='button' onClick={() => {
                            obtenerInfoPlan();

                            setInfoPlan({
                                ModalVisible: true, Titulo: 'Generar plan'
                            });
                        }}>
                            <FaRegClipboard size={'0.8rem'} />
                        </Button>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={12} md={12}>
                <div className='table-responsive' style={{ maxHeight: '300px', overflowY: 'auto', display: 'block' }}>
                    <table className='table table-borderless table-hover'>
                        <thead>
                            <tr style={{ textAlign: 'left', borderBottom: '1px solid #ddd' }}>
                                <th className="estilo-encabezado" style={{ fontSize: 13 }}></th>
                                <th className="estilo-encabezado" style={{ fontSize: 13 }}>#</th>
                                <th className="estilo-encabezado" style={{ fontSize: 13 }}>Código</th>
                                <th className="estilo-encabezado" style={{ fontSize: 13 }}>Producto</th>
                                <th className="estilo-encabezado" style={{ fontSize: 13 }}>Cant</th>
                                <th className="estilo-encabezado" style={{ fontSize: 13 }}>Precio</th>
                                <th className="estilo-encabezado" style={{ fontSize: 13 }}>Vlr bruto</th>
                                <th className="estilo-encabezado" style={{ fontSize: 13 }}>% Desc</th>
                                <th className="estilo-encabezado" style={{ fontSize: 13 }}>Subtotal</th>
                                <th className="estilo-encabezado" style={{ fontSize: 13 }}>Imp</th>
                                <th className="estilo-encabezado" style={{ fontSize: 13 }}>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {detalles.map((item, i) => (
                                <tr key={i}>
                                    <td>
                                        <Button type="button" variant="danger" onClick={() => eliminarDetalle(item.facturadetid)}
                                            style={{
                                                fontWeight: "bold",
                                                textAlign: "center",
                                                fontSize: 10
                                            }}>
                                            <FaTrash />
                                        </Button>
                                    </td>
                                    <td className="text-center" style={{ fontSize: 13 }}>
                                        {i + 1}
                                    </td>
                                    <td className="text-center" style={{ fontSize: 13 }}>
                                        {item.codigo}
                                    </td>
                                    <td className="text-center" style={{ fontSize: 13 }}>
                                        {item.descripcion}
                                    </td>
                                    <td className="text-center" style={{ fontSize: 13 }}>
                                        {formatNumber(item.cantidad)}
                                    </td>
                                    <td style={{ textAlign: 'right', fontSize: 13 }}>
                                        ${formatNumber(item.precio)}
                                    </td>
                                    <td style={{ textAlign: 'right', fontSize: 13 }}>
                                        ${formatNumber(item.vlrBruto)}
                                    </td>
                                    <td style={{ textAlign: 'right', fontSize: 13 }}>
                                        {formatNumber(item.descuento)}
                                    </td>
                                    <td style={{ textAlign: 'right', fontSize: 13 }}>
                                        ${formatNumber(item.subtotal)}
                                    </td>
                                    <td style={{ textAlign: 'right', fontSize: 13 }}>
                                        ${formatNumber(item.impuesto)}
                                    </td>
                                    <td style={{ textAlign: 'right', fontSize: 13 }}>
                                        ${formatNumber(item.total)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Grid>

        </Grid>

        <Modal
            show={infoPlan.ModalVisible}
            size="lg"
            onHide={() => {
                setInfoPlan({
                    ModalVisible: false, Titulo: ''
                });

                setDataPlan({});
            }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{infoPlan.Titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-3">
                        <FloatingLabel
                            controlId='tipoPlanNewInput'
                            label="Tipo plan"
                            className="form-floating-sm"
                        >
                            <Form.Select
                                value={dataPlan.tipoPlan}
                                onChange={event => {
                                    setDataPlan({ ...dataPlan, tipoPlan: event.target.value });

                                    calculaFechasPlan(event.target.value);
                                }}
                                className="input-fecha-sm"
                            >
                                <option value="">Seleccione</option>
                                <option value="true">Principal</option>
                                <option value="false">Extensión</option>
                            </Form.Select>
                        </FloatingLabel>
                    </div>
                    <div className="col-md-3">
                        <FloatingLabel controlId="tipoPlanNewInput" label="Plan" className="form-floating-sm">
                            <Form.Control
                                as="input"
                                type="text"
                                value={dataPlan.plan}
                                placeholder=" "
                                className="input-fecha-sm"
                                readOnly
                            />
                        </FloatingLabel>
                    </div>
                    <div className="col-md-3">
                        <FloatingLabel controlId="desdeNewInput" label="Desde" className="form-floating-sm">
                            <Form.Control
                                as="input"
                                type="date"
                                value={dataPlan.fechaIni}
                                onChange={event => setDataPlan({ ...dataPlan, fechaIni: event.target.value })}
                                placeholder=" "
                                className="input-fecha-sm"
                            />
                        </FloatingLabel>
                    </div>
                    <div className="col-md-3">
                        <FloatingLabel controlId="finNewInput" label="Hasta" className="form-floating-sm">
                            <Form.Control
                                as="input"
                                type="date"
                                value={dataPlan.fechaFin}
                                onChange={event => setDataPlan({ ...dataPlan, fechaFin: event.target.value })}
                                placeholder=" "
                                className="input-fecha-sm"
                            />
                        </FloatingLabel>
                    </div>
                </div>
                <div className="row" style={{ marginTop: 10 }}>
                    <div className="col-md-3">
                        <FloatingLabel
                            controlId='tipoPagoNewInput'
                            label="Tipo pago"
                            className="form-floating-sm"
                        >
                            <Form.Select
                                value={dataPlan.tipoPago}
                                onChange={event => {
                                    const tipoPagoValue = event.target.value;

                                    if (tipoPagoValue === "true") {
                                        // Proceso para ANUAL: carga el valor anual original y cambia valorMes
                                        setDataPlan({
                                            ...dataPlan,
                                            tipoPago: tipoPagoValue,
                                            valorAnual: dataPlan.valorAnualOriginal,
                                            valorMes: Math.round(dataPlan.valorAnualOriginal / 12)
                                        })
                                    } else if (tipoPagoValue === "false") {
                                        // Proceso para MENSUAL: carga el valor mensual original y cambia valorMes
                                        setDataPlan({
                                            ...dataPlan,
                                            tipoPago: tipoPagoValue,
                                            valorAnual: Math.round(dataPlan.valorMesOriginal * 12),
                                            valorMes: dataPlan.valorMesOriginal
                                        })
                                    } else {
                                        // Si no selecciona nada
                                        setDataPlan({ ...dataPlan, tipoPago: tipoPagoValue })
                                    }
                                }}
                                className="input-fecha-sm"
                            >
                                <option value="">Seleccione</option>
                                <option value="true">Anual</option>
                                <option value="false">Mensual</option>
                            </Form.Select>
                        </FloatingLabel>
                    </div>
                    <div className="col-md-3">
                        <FloatingLabel controlId="foliosMesNewInput" label="Folios mes" className="form-floating-sm">
                            <Form.Control
                                as="input"
                                type="number"
                                value={formatNumber(dataPlan.foliosMes)}
                                placeholder=" "
                                className="input-fecha-sm"
                                readOnly
                            />
                        </FloatingLabel>
                    </div>
                    <div className="col-md-3">
                        <FloatingLabel controlId="foliosAnualNewInput" label="Folios anual" className="form-floating-sm">
                            <Form.Control
                                as="input"
                                type="number"
                                value={formatNumber(dataPlan.foliosAnual)}
                                placeholder=" "
                                className="input-fecha-sm"
                                readOnly
                            />
                        </FloatingLabel>
                    </div>
                    <div className="col-md-3">
                        <FloatingLabel controlId="valorMesNewInput" label="Valor mes" className="form-floating-sm">
                            <Form.Control
                                as="input"
                                type="text"
                                value={formatNumber(dataPlan.valorMes)}
                                placeholder=" "
                                className="input-fecha-sm"
                                readOnly
                            />
                        </FloatingLabel>
                    </div>
                </div>
                <div className="row" style={{ marginTop: 10 }}>
                    <div className="col-md-3">
                        <FloatingLabel controlId="valorAnualNewInput" label="Valor anual" className="form-floating-sm">
                            <Form.Control
                                as="input"
                                type="text"
                                value={formatNumber(dataPlan.valorAnual)}
                                placeholder=" "
                                className="input-fecha-sm"
                                readOnly
                            />
                        </FloatingLabel>
                    </div>
                    <div className="col-md-3">
                        <FloatingLabel controlId="facturaNewInput" label="Factura" className="form-floating-sm">
                            <Form.Control
                                as="input"
                                type="text"
                                value={dataPlan.factura}
                                placeholder=" "
                                className="input-fecha-sm"
                                readOnly
                            />
                        </FloatingLabel>
                    </div>
                    <div className='col-md-1'>
                        <label>Reserva</label>
                        <Form.Check
                            style={{ textAlign: 'center', justifyContent: 'center' }}
                            required
                            checked={dataPlan.reserva}
                            onChange={event => setDataPlan({ ...dataPlan, reserva: event.target.checked })}
                        />
                    </div>
                    <div className="col-md-1">
                        <Button variant='success' type='button' onClick={() => {
                            generarPlan(dataPlan);
                        }}>
                            <FaSave size={'1rem'} />
                        </Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>

        <Modal
            show={modalPrecio.ModalVisible}
            size="lg"
            onHide={() => {
                setModalPrecio({
                    ModalVisible: false, Titulo: ''
                });
            }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{modalPrecio.Titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='table-responsive' style={{ maxHeight: '300px', overflowY: 'auto', display: 'block' }}>
                    <table className='table table-borderless table-hover'>
                        <thead>
                            <tr>
                                <th className="estilo-encabezado" style={{ fontSize: 13 }}>
                                    Precio
                                </th>
                                <th className="estilo-encabezado" style={{ fontSize: 13 }}>

                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {listPrecios.map((item, index) => (
                                <tr key={index}>
                                    <td className="text-center" style={{ fontSize: 13 }}>
                                        {formatNumber(item)}
                                    </td>
                                    <td>
                                        <Button type="button" variant="success" onClick={() => {
                                            let vlrBruto = Math.round((item * dataFactura.Cantidad) * 100) / 100;
                                            let descuento = Math.round(vlrBruto * (dataFactura.Descuento / 100) * 100) / 100;
                                            let subtotal = Math.round((vlrBruto - descuento) * 100) / 100;
                                            let impuesto = Math.round(subtotal * (dataFactura.Impuesto_porc / 100) * 100) / 100;
                                            let total = Math.round((subtotal + impuesto) * 100) / 100;

                                            setDataFactura({ ...dataFactura, Precio: item, Total: total, Subtotal: subtotal, VlrBruto: vlrBruto, Impuesto: impuesto });

                                            setModalPrecio({
                                                ModalVisible: false,
                                                Titulo: ''
                                            });
                                        }}
                                            style={{
                                                fontWeight: "bold",
                                                textAlign: "center",
                                                fontSize: 10
                                            }}>
                                            <FaCheck />
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Modal.Body>
        </Modal>

    </div >
}

export default FacturaCRUD;